import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { DTMAINCacheViewModel } from './dTMAINCacheViewModel'

export class DTMAINCacheContainer extends MasterDataContainer<DTMAINCacheViewModel> {
    constructor(models: Array<DTMAINCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
